/**
 * Extract region from SoW number.
 * SoW number format: EIP{regionCode}SoWT{tier}{seq}
 * e.g., "EIPNFSoWT31009" → "NF" → "northForge"
 *
 * Shared by client (display/tax config) and server (audit-gate routing).
 */

import { Region } from "./common.types";

const REVERSE_REGION_CODES: Record<string, Region> = {
  CT: "communitech",
  NF: "northForge",
  IO: "investOttawa",
  LL: "launchLab",
  SC: "sparkCenter",
};

export function extractRegionFromSowNumber(
  sowNumber: string | undefined
): Region | null {
  if (!sowNumber || sowNumber.length < 5) return null;
  const code = sowNumber.substring(3, 5);
  return REVERSE_REGION_CODES[code] || null;
}
